<template>
  <div class="game">
    <div id="head-page" class="globulo parallaxe">
      <parallax>
        <div id="bg1" data-depth="0.3"><img class="" src="@/assets/images/head/sun.png" alt="" title="" /></div>
        <div id="bg2" data-depth="0.2"><img class="" src="@/assets/images/head/colines.png" alt="" title="" /></div>
        <div id="bg3" data-depth="0.1"><img class="" src="@/assets/images/head/montagnes.png" alt="" title="" /></div>
        <div id="bg4" data-depth="0.2"><img class="" src="@/assets/images/head/sapins.png" alt="" title="" /></div>
        <div id="bg5" data-depth="0.5"><img class="" src="@/assets/images/head/nuages.png" alt="" title="" /></div>
        <div id="front-1" data-depth="0.2"></div>
      </parallax>
    </div>

    <div class="grid-container content-page fiche-jeu">
      <div class="grid-x grid-margin-x">
        <div class="small-12 cell">
          <title-page attrpage="Mini jeux" baseline="À toi de jouer !">Préparation à la greffe</title-page>
          <p>La greffe de moelle osseuse consiste à remplacer les cellules malades de ta moelle par des
          cellules saines d’une autre personne, appelée donneur. Toi tu seras le receveur, la personne
          qui reçoit la nouvelle moelle. La moelle contient des cellules souches dites hématopoïétiques
          qui normalement se transforment en cellules du sang : les globules rouges, les globules
          blancs et les plaquettes. Dans le cas d’une leucémie, la transformation ne fonctionne pas
          bien donc on remplace ta moelle par une autre en faisant passer les cellules dans le cathéter.<br>
          Mais avant cela, pour que ton corps accepte bien ces nouvelles cellules, il faut le préparer et
          supprimer les cellules malades avec des médicaments.</p>

          <p>Regarde comment ça se passe dans ce mini-jeu.</p>

          <p>Fiches associées :</p>
					<ul>
          	<li>Mon enfant va recevoir une allogreffe de cellules souches hématopoïétiques (SFGM-TC)</li>
          	<li>Glossaire - Allogreffe de moelle osseuse (SFGM-TC et Genzyme)</li>
          	<li>Fonctionnement de la moelle osseuse, introduction notion de greffe (SFGM-TC)</li>
					</ul>
          <div v-if="$isDesktop()" class="box-game">
            <div class="content-game">
              <godot-game
                v-bind="gameInfos"
                @game_finished="endGame"
              />
            </div>
          </div>
          <div v-else>
            <div class="bt-game-mobile chimio">
              <bouton href="/games/decouverte/index.html">Accéder au jeu</bouton>
            </div>
          </div>

          <div class="grid-x grid-margin-x">
            <div class="small-12 cell">
              <h3>Les ressources complémentaires</h3>
            </div>

            <div v-for="fiche in fiches" class="small-12 medium-6 large-4 cell">
              <item-fiche
                :lien="fiche.url"
                :titlebox="fiche.title"
                :type-item="fiche.type">
                {{ fiche.content }}
              </item-fiche>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import TitlePage from '@/components/TitlePage'
  import Bouton from '@/components/Bouton.vue'
  import ItemFiche from '@/components/ItemFiche'
  import GodotGame from '@/components/GodotGame'

  import splashFLE from '@/assets/images/games/splash/splash-fle.jpg'
  import splashGame from '@/assets/images/games/splash/splash-conditionnement.jpg'
  import FichesDB from '@/datas/fiches'

  export default {
    props: ['gameId'],
    components: { TitlePage, Bouton, ItemFiche, GodotGame },
    data () {
      const me = this.$store.state.me
      const playerInfos = {
        gender: (me.gender === 'H' ? 'boy' : 'girl'),
        playerName: `${me.first_name} ${me.last_name}`,
      }
      return {
        gameInfos: {
          pck: 'jeu-conditionnement',
          engineVersion: 'full-3.2.1',
          splashStack: [
            {
              outerBarColor: '#01b1c8',
              innerBarColor: '#e43516',
              backgroundColor: '#FFF',
              duration: 2000,
              splashUrl: splashFLE
            },
            {
              outerBarColor: '#466C91',
              innerBarColor: '#5FABE3',
              backgroundColor: '#000',
              duration: 2000,
              splashUrl: splashGame
            },
          ],
          playerInfos,
        },
        fichesIds: [21, 22, 25],
        fiches: []
      }
    },
    computed: {
      currentUser() {
        return this.$store.state.me
      }
    },
    async mounted () {
      const fichesDB = await FichesDB();
      this.fiches =  this.fichesIds.map((fid) => fichesDB.find(f => f.id === fid) )
    },
    methods: {
      endGame() {
        if (this.currentUser.account_type === 'child') {
          this.$store.dispatch('playGame', this.gameId)
        }
      }
    }
  }
</script>
